import { z } from 'zod';

const phoneRegex = /^\(\d{3}\)\s\d{3}-\d{4}$/;

const dateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/);

// Signup schema with all required fields
const signUpSchema = z
  .object({
    name: z.string().min(2, 'Name is required.').max(100),
    phone: z
      .string()
      .min(10, 'Valid 10 digit number required.')
      .max(14, 'Valid 10 digit number required.'),
    email: z.string().min(1, 'Email is required').email('Invalid email'),
    password: z
      .string()
      .min(1, 'Password is required')
      .min(8, 'Password must have at least 8 characters'),
    confirmpassword: z
      .string()
      .min(1, 'Confirm Password is required'),
  })
  .refine((data) => data.password === data.confirmpassword, {
    message: 'Passwords do not match',
    path: ['confirmpassword'],
  });

// TODO: Fix datetime eventually.
const rideSchema = z.object({
  name: z.string().min(2, 'Name is required.'),
  phone: z.string().regex(phoneRegex, 'Valid 10 digit number required.'),
  passengers: z.number().int().min(0),
  pickUp: z.string().min(4, 'An address is required.'),
  dropOff: z.string().min(4, 'An address is required.'),
  pickUpTime: z.string(),
  // date: z.string().date().optional(),
});

export { signUpSchema, rideSchema };
